import React from 'react';
import { CircleXIcon, SparklesIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const pains = ['Domingo buscando progresiones que no terminan de encajar con el nivel de tus alumnas.', 'Clases armadas la noche anterior, sin criterio de progresión claro.', 'Siempre los mismos circuitos porque no tenés un banco de ejercicios serio.', 'La vertical, la rondada, el kip en barras — sin sistema de etapas definido.', 'Grupos con distintos niveles sin material diferenciado: enseñás al promedio y perdés a todos.', 'Fin de semana agotado. El domingo volvió a empezar el mismo ciclo.'];
const transformations = ['Sin buscar ejercicios en internet', 'Progresiones etapa por etapa', 'Criterios de avance medibles', 'Clases listas en 10 minutos'];
export function PainAndTransformation() {
  return <>
      <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-213" data-mp="63kmbwittzju">
        <div className="mx-auto max-w-4xl" data-id="element-214" data-mp="10w2syb3a07xy">
          <Eyebrow danger data-id="element-215" data-mp="10x4dd666m6sc">😤 La realidad</Eyebrow>
          <SectionTitle data-id="element-216" data-mp="14x4u4xgr6u2k">
            ¿Cuántos domingos más <span className="text-gold" data-id="element-217" data-mp="14w3fkj0j3pg3">vas a perder así?</span>
          </SectionTitle>
          <p className="mx-auto mt-6 max-w-3xl text-center font-medium text-zinc-400" data-id="element-218" data-mp="qwkdo7yb9ac8">
            Sos entrenador de gimnasia artística. Amás el deporte. Pero nadie te dijo que ibas a
            pasar los domingos buscando ejercicios que no encajan, armando clases a la noche y
            llegando al lunes con material que “más o menos sirve”.
          </p>
          <ul className="mt-9 grid gap-3 sm:grid-cols-2 md:gap-4" data-id="element-219" data-mp="87e0f0gadaxt">
            {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-line bg-ink p-4" data-id="element-220" data-mp="d5yzgwjsxoko">
                <CircleXIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-red-400" data-id="element-221" data-mp="3uf45j9d2ue6i" />
                <span className="text-sm font-medium text-zinc-300 md:text-base" data-id="element-222" data-mp="379id5zqc85h">{pain}</span>
              </li>)}
          </ul>
          <p className="mt-10 rounded-2xl border border-gold/30 bg-gold/[0.06] p-6 text-center text-lg font-bold text-zinc-200 md:text-2xl" data-id="element-223" data-mp="3bidgn20fuxn1">
            No es falta de vocación.
            <br data-id="element-224" data-mp="36go1pba3hzto" />
            <span className="text-xl text-gold md:text-3xl" data-id="element-225" data-mp="31k60umhvylmm">Es falta de un sistema.</span>
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:py-16" data-id="element-226" data-mp="318x4pkhkifx">
        <Eyebrow data-id="element-227" data-mp="3u8uu5zcp9mnt">
          <span className="inline-flex items-center gap-2" data-id="element-228" data-mp="3u8blzacuqcmz">
            <SparklesIcon aria-hidden="true" className="h-4 w-4" data-id="element-229" data-mp="3u6qtdqa3l3rr" /> La transformación
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-230" data-mp="3kanq2h3iez38">
          ¿Y si este fuera <span className="text-gold" data-id="element-231" data-mp="3k9m43hkygs6q">el último domingo que pasó así?</span>
        </SectionTitle>
        <div className="mt-8 rounded-3xl border border-gold/25 bg-surface p-6 md:p-10" data-id="element-232" data-mp="2dv4m6higme8w">
          <p className="text-center text-base font-bold leading-relaxed text-white md:text-xl" data-id="element-233" data-mp="28u75k9d3ls9i">
            Abrís el tomo del aparato. Elegís el nivel. Tomás el circuito. En 10 minutos la clase
            está cerrada y el domingo vuelve a ser tuyo.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-234" data-mp="ybnkesfdgzcn">
            {transformations.map(item => <p key={item} className="rounded-xl border border-gold/25 bg-ink p-3 text-center text-xs font-bold text-gold md:text-sm" data-id="element-235" data-mp="132dp03fz4y6a">
                {item}
              </p>)}
          </div>
          <p className="mt-6 text-center font-medium text-zinc-400" data-id="element-236" data-mp="1c4vaugrpvosr">
            Eso es el{' '}
            <strong className="text-white" data-id="element-237" data-mp="1gzshxi5fro30">Combo Completo Gimnasia Artística 2026.</strong>
          </p>
        </div>
        <div className="mt-8 text-center" data-id="element-238" data-mp="3it89qid9f8zk">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-239" data-mp="3iu9wvl7jvlxn">
            Quiero mi Combo Completo ahora →
          </Button>
        </div>
      </section>
    </>;
}